import getComplectations from '../../../api/cars/getComplectations';
import createComplectation from '../../../api/cars/createComplectation';
import getEngineCar from '../../../api/cars/getEngineCar';
import { ENGINE_TYPE_OPTIONS } from './carInfoInputs';

// Названия двигателя в справочнике разные на разных контурах («Бензин»,
// «Electric», «Электрический»), поэтому ищем по списку синонимов, а не по
// точному совпадению.
const ENGINE_SYNONYMS = {
  PETROL: ['бензин', 'petrol', 'gasoline'],
  DIESEL: ['дизель', 'diesel'],
  GAS_PETROL: ['газ-бензин', 'газ бензин', 'gas-petrol'],
  GAS: ['газ', 'gas', 'lpg'],
  HYBRID: ['гибрид', 'hybrid'],
  ELECTRIC: ['электричество', 'электрический', 'электро', 'electric'],
};

const norm = (value) => String(value ?? '').trim().toLowerCase();

/** Запись справочника двигателей под выбранный на форме тип. */
export const findEngine = (engines, engineType) => {
  const list = Array.isArray(engines) ? engines : [];
  const synonyms = ENGINE_SYNONYMS[engineType] || [];
  const byTitle = list.find((engine) => synonyms.includes(norm(engine?.title)));
  // Неизвестный тип или пустой справочник: берём первый, иначе комплектация
  // уйдёт с engineId = 0 и банк получит машину без типа топлива.
  return byTitle || list[0] || null;
};

/** Название комплектации-заглушки: то же, что менеджер выбрал в «Типе двигателя». */
export const complectationTitleFor = (engineType) =>
  ENGINE_TYPE_OPTIONS.find((option) => option.value === engineType)?.label || 'Базовая';

/**
 * Комплектация для короткой формы: менеджеру её не показываем, но без неё авто
 * не добавить в сделку — тип топлива, объём и коробку банки берут именно оттуда.
 *
 * Заводим по одной на тип двигателя в пределах марки с моделью и переиспользуем:
 * вторая машина с тем же топливом новой записи в справочнике не создаёт.
 */
const ensureComplectation = async ({ containerId, engineType }) => {
  if (!containerId) throw new Error('Не удалось определить марку и модель автомобиля');

  const title = complectationTitleFor(engineType);
  const existing = await getComplectations({ containerId, used: true });
  const found = (existing?.data || []).find((item) => norm(item?.title) === norm(title));
  if (found?.id) return found.id;

  const engines = await getEngineCar();
  const engine = findEngine(engines?.data, engineType);

  const created = await createComplectation({
    title,
    containerId,
    used: true,
    engineId: engine?.id ?? 1,
    // Кузов и привод на короткой форме не спрашиваем — ставим те же значения,
    // что и ручное заведение комплектации в селекте.
    carcaseId: 1,
    wdId: 2,
  });
  const id = Number(created?.data);
  if (!id) throw new Error('Не удалось подобрать комплектацию');
  return id;
};

export default ensureComplectation;
